import type { AdminRobot, NewAdminRobot } from '@/models/AdminRobot';
import CoreApi from '@/api/CoreApi';

export async function loadAdminRobots(): Promise<AdminRobot[]> {
  try {
    const response = await CoreApi.axiosClient.get('/admin/control-units');
    return response.data;
  } catch (error) {
    console.error(error);
    throw new Error('Failed to load admin robots');
  }
}

export async function patchAdminRobot(robotToPatch: AdminRobot): Promise<void> {
  try {
    await CoreApi.axiosClient.patch('/admin/control-units', robotToPatch);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (error: any) {
    console.error(error);
    throw new Error(error);
  }
}

export async function createAdminRobot(newRobot: NewAdminRobot): Promise<void> {
  try {
    await CoreApi.axiosClient.post('/admin/control-units', newRobot);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (error: any) {
    console.error(error);
    throw new Error(error);
  }
}

export async function deleteAdminRobot(
  robotToDelete: AdminRobot,
): Promise<void> {
  try {
    await CoreApi.axiosClient.delete(
      `/admin/control-units/${robotToDelete.serialNumber}`,
    );
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (error: any) {
    console.error(error);
    throw new Error(error);
  }
}

export async function getRobotPassword(robot: AdminRobot): Promise<string> {
  try {
    const response = await CoreApi.axiosClient.get(
      `/admin/control-units-password/${robot.serialNumber}`,
    );
    return response.data;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (error: any) {
    console.error(error);
    throw new Error(error);
  }
}
